<template>
    <b-modal id="modal-prizedetail" centered class="modal-prizedetail">
      <div class="modal-prizedetail-itens">
        <button
          class="modal-prizedetail-itens-close"
          @click="$bvModal.hide('modal-prizedetail')"
        >
        <svg xmlns="http://www.w3.org/2000/svg" width="33.598" height="17.831" viewBox="0 0 33.598 17.831">
            <g id="Group_2368" data-name="Group 2368" transform="translate(-42.507 -69.243)">
                <path id="Union_1" data-name="Union 1" d="M10.925,0h.683V11.608h-.683V.683H0V0Z" transform="translate(67.19 86.367) rotate(-135)" fill="#173f35" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                <path id="Union_1-2" data-name="Union 1" d="M10.925,0h.683V11.608h-.683V.683H0V0Z" transform="translate(51.422 69.95) rotate(45)" fill="#173f35" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            </g>
        </svg>
        </button>
      </div>
      <div class="modal-prizedetail-content">
        <h3>{{ prizes.name }}</h3>    
        <div class="row modal-prizedetail-content-item">
          <div class="col-md-6 modal-prizedetail-content-item-img">
            <img :src="prizes.prize_path" alt="Prize">
          </div>
          <div v-html="prizes.description" class=" col-md-6 modal-prizedetail-content-item-text">
          </div>
        </div>   
      </div>
    </b-modal>
  </template>
  
  <script> 
  
  export default {
    props: {
      prizes: {
        type: Object,
        default: () => {},
      },
    },
  };
  </script>
  
  <style lang="scss" >
  #modal-prizedetail {
    .modal-header,
    .modal-footer {
      display: none;
    }
    .modal-dialog {
      max-width: 825px;
      margin: auto!important;;
      @media screen and (max-width: 991px) {
        max-width: 384px;
      }
    }
    .modal-content {
      border-radius: 0;
      border: 0;
      background-color: #F6F6F6!important;
    }
    .modal-body {
      height: 477px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 15px;
      @media (max-width: 991px) {
        padding: 50px 20px;
        height: auto;
      }
    }
  }
  .modal-prizedetail {
    &-itens {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      &-close {
        position: absolute;
        right: -20px;
        top: -40px;
        width: 83px;
        height: 83px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: black;
        border: 1px solid black;
        border-radius: 50%;
        transition: 500ms;
        @media (max-width: 991px) {
          top: 20px;
          right: 20px;
          width: 40px;
          height: 40px;
          svg {
            max-width: 15px;
          }
        }
        &:hover,
        &:focus {
          opacity: 0.6;
        }
      }
    }
    &-content{
        max-height: 290px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        gap: 20px;
        padding: 0 25px;
        @media screen and (max-width: 991px){
          max-height: 100%;
        }
        &-item{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          max-height: 250px;
          overflow: hidden;
          @media screen and (max-width: 991px){
            flex-direction: row;
            max-height: 100%;
          }
          &-img{
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            img{
              height: 250px;
              width: auto;
              max-width: 100%;
              max-height: 100%;
            }
          }
        }
    }
  }
</style>